module.exports = __webpack_public_path__ + "img/noAuthority.2258f0a1.png";